import React, {Component} from 'react';
import { Modal, Spin, message } from 'antd';
import {delResource, loadInterviewResource, videoConvertParams} from "../../actions/interview";
import TaskUpload from "../../view/components/taskUpload/taskUpload";
import ChunkUpload from '../upload/ChunkUpload';
import {checkFileStatus} from "../../actions/upload";
import UploadWall from "../upload/UploadWall";
import {Scrollbars} from "react-custom-scrollbars";
import {VIDEO_TYPE} from "../../constants/index";

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}


class NewsActivityVideo extends Component {

    state = {
        load: false,//是否加载完成
        previewVisible: false,
        previewImage: '',
        fileList: [],
    };

    componentDidMount() {
        this.loadFileList(this.props.data);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.loadFileList(nextProps.data);
    }

    loadFileList = (data)=>{
        if(data && data.id > 0){
            //加载采访任务的资源
            loadInterviewResource(data.id, (res)=>{
                this.setState({
                    load:true,
                    fileList:(()=>{
                        let fileList = [];
                        res && res.videoList && res.videoList.map((item)=>{
                            if(item){
                                fileList.push({
                                    resourceId:item.resourceId,
                                    uid: parseInt(item.id) * -1,
                                    oldId:item.id,
                                    name: item.name,
                                    status: 'done',
                                    url: item.path.replace(/(\/storage\/[a-zA-Z0-9]{32}).*/, "$1") +  + "/thumbnails/1",
                                    videoUrl: item.path
                                })
                            }
                        });
                        return fileList;
                    })()
                })
            })
        }else{
            this.setState({
                load: true,
            });
            message.error("加载出错");
        }
    };

    handleCancel = () => this.setState({ previewVisible: false });

    handlePlay = async file => {
        this.setState({
            previewImage: file.videoUrl,
            previewVisible: true,
        });
    };

    /**
     * 是否有上传的权限
     * @param newsActivity
     * @param currentUser
     * @returns {boolean}
     */
    isHaveUploadAuth=(newsActivity, currentUser)=>{
        let auth = false;
        if(newsActivity && currentUser && (newsActivity.status < 3)){
            //查看当前的记者有哪些角色
            if(newsActivity.interviewJointers){
                newsActivity.interviewJointers.map(jointer=>{
                    if(jointer.account === currentUser.account){
                        //判断是否已经领取了
                        if((jointer.status < 3) && (jointer.interviewRole === 3)){//是摄像记者并且已领取才显示
                            auth = true;
                        }
                    }
                });
            }
        }
        return auth;
    };

    handleChange = ({ file, fileList }) => {
        if(file.status === "done"){
            file.response.interviewId = this.props.data ? this.props.data.id : 0;
            videoConvertParams(file.response, file, (res)=>{
                this.checkStatus(file.response.storageFile.md5, (stateStr)=>{
                    let newFileList = fileList.map(item=>{
                        if(item.uid === file.uid){
                            item.resourceId = res.resourceId;
                            item.url = "";
                            item.ingStatus = stateStr;
                            item.videoUrl = res.path;
                        }
                        return item;
                    });
                    this.setState({ fileList:newFileList });
                },()=>{
                    let newFileList = fileList.map(item=>{
                        if(item.uid === file.uid){
                            item.resourceId = res.resourceId;
                            item.url = res.path.replace(/(\/storage\/[a-zA-Z0-9]{32}).*/, "$1") + "/thumbnails/1" + "?version="+Math.random();
                            item.videoUrl = res.path;
                        }
                        return item;
                    });
                    this.setState({ fileList:newFileList });
                });
            });
        }
        this.setState({ fileList });
    };

    //检查上传之后的状态，视频有的时候需要查看是否合并完成了
    checkStatus(md5, ingCallBack, overCallBack){
        setTimeout(()=>{
            checkFileStatus(md5).then(res=>{
                if(res.state !== "mergeComplete"){
                    this.checkStatus(md5, ingCallBack, overCallBack);
                    ingCallBack(res.stateStr);
                }else{
                    overCallBack();
                }
            }).catch(()=>{
                overCallBack();
            });
        }, 100);//每隔一秒钟进行检查一次
    }

    handleRemove = async file => {
        delResource(this.props.data.id, file.resourceId);
        this.setState(prevState => {
            let fileList = prevState.fileList.filter(item=>{
                return item.uid !== file.uid
            });
            return {
                fileList
            }
        });
    };

    render() {
        const { previewVisible, previewImage, fileList, load } = this.state;
        return (
            <div style={{ padding: 15, background: '#f4f6fc'}}>
                <TaskUpload 
                    fileType={3}
                    icons={["eye", "download", "delete"]}
                    taskId={this.props.data.id}
                    data={this.props.data}
                />
            </div>
        );
    }
}

export default NewsActivityVideo;